module.exports = __webpack_public_path__ + "img/accesorios.f449a8e4.svg";